'use client'
import React, { FunctionComponent, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import Image from 'next/image'
import classNames from 'classnames'
import { Input } from '@/components/Input'
import { Button } from '@/components/Button'
import { phoneMask } from '@/utils/inputMask'

import { ExpertHelpStatus, ExpertHelpStore } from './ExpertHelp.store'

import ImageCircles from './images/circles.png'
import ImagePhoto from './images/photo.png'

import { IconPhone } from './icons/phone'
import { IconLoader } from './icons/loader'
import { IconCheck } from './icons/check'

import styles from './ExpertHelp.module.scss'
import { HelpData, HelpType } from '@/services/Api/generated'

type ExpertHelpProps = {
  className?: string
  type: HelpType
  data?: HelpData
  theme?: 'simple' | 'certificates' | 'registryPage' | 'onlineSearch'
}
export const ExpertHelp: FunctionComponent<ExpertHelpProps> = observer(
  ({ className, type, data, theme }) => {
    const [store] = useState(() => new ExpertHelpStore())

    useEffect(() => {
      store.setData(data)
    }, [data, store])

    useEffect(() => {
      store.setType(type)
    }, [type, store])

    return (
      <div className={className}>
        <div
          className={classNames({
            [styles.container]: true,
            [styles.isSimple]: theme === 'simple',
            [styles.isCertificates]: theme === 'certificates',
            [styles.isRegistryPage]: theme === 'registryPage',
            [styles.isOnlineSearch]: theme === 'onlineSearch',
          })}
        >
          <div className={styles.background}>
            <Image src={ImageCircles} alt="" width={570} height={570} />
            <Image
              className={styles.backgroundPhoto}
              src={ImagePhoto}
              alt=""
              width={80}
              height={80}
            />
          </div>
          <div className={styles.header}>
            <div className={styles.title}>
              {store.status === ExpertHelpStatus.WAIT
                ? 'Нужна помощь эксперта?'
                : 'Спасибо за обращение!'}
            </div>
            <div className={styles.description}>
              {store.status === ExpertHelpStatus.WAIT
                ? 'Оставьте номер телефона, мы перезвоним и проконсультируем по всем интересующим вас вопросам'
                : 'Мы получили вашу заявку. В ближайшее время наш эксперт свяжется с вами.'}
            </div>
          </div>

          <div className={styles.form}>
            <Input
              className={styles.input}
              placeholder="+7 (___) ___-__-__"
              mask={phoneMask}
              value={store.phone}
              onChange={store.setPhone}
            />
            <Button
              variant={
                theme === 'certificates' ||
                theme === 'registryPage' ||
                theme === 'onlineSearch'
                  ? 'primary'
                  : 'secondary'
              }
              className={styles.button}
              onClick={store.sendRequest}
              isLoading={store.isLoading}
            >
              {store.status === ExpertHelpStatus.WAIT ? (
                <>
                  Получить консультацию
                  {theme !== 'certificates' &&
                  theme !== 'registryPage' &&
                  theme !== 'onlineSearch' ? (
                    <IconPhone className={styles.iconPhone} />
                  ) : null}
                </>
              ) : null}
              {store.status === ExpertHelpStatus.SENT ? (
                <div className={styles.buttonReady}>
                  Готово
                  <IconCheck className={styles.buttonReadyIcon} />
                </div>
              ) : null}
              {store.status === ExpertHelpStatus.EDITED ? (
                <>
                  Отправить повторно
                  <IconLoader className={styles.loaderIcon} />
                </>
              ) : null}
            </Button>
          </div>
        </div>
      </div>
    )
  }
)
